export default class WidgetGeneralHeaderCtrl {
  onClick() {
    this.isSettings = !this.isSettings;
    this.onSettingsClick({ clicked: this.isSettings });
  }
}
